import type { FC } from 'react';

import { gql } from '@apollo/client';
import { useFeatureFlagBool } from '@modernloop/shared/feature-flag';

import { useRecruitingSessionActivityTimeoutQuery } from 'src/generated/mloop-graphql';

import useAuth from 'src/hooks/useAuth';

import { isGraphqlPermissionError } from 'src/shared/app/graphqlPermissionError';
import SessionInactivityTimeout from 'src/shared/app/SessionInactivityTimeout';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- used by codegen
const RecruitingSessionActivityTimeoutQuery = gql`
  query RecruitingSessionActivityTimeout {
    thisOrg {
      id
      sessionInactivityTimeout {
        seconds
        nanos
      }
    }
  }
`;

/**
 * Loads the hiring-dashboard session timeout from scheduler GraphQL and enforces it when available.
 */
const HiringDashboardSessionActivityTimeout: FC = () => {
  const enabled = useFeatureFlagBool('SESSION_INACTIVITY_TIMEOUT');
  const { isAuthenticated } = useAuth();

  const { data, error, loading } = useRecruitingSessionActivityTimeoutQuery({
    errorPolicy: 'all',
    skip: !enabled || !isAuthenticated,
  });

  if (!enabled || loading) {
    return null;
  }

  const timeoutDuration = isGraphqlPermissionError(error) ? null : data?.thisOrg?.sessionInactivityTimeout;

  return <SessionInactivityTimeout timeoutDuration={timeoutDuration} />;
};

export default HiringDashboardSessionActivityTimeout;
